export class NcalayerUnavailableError extends Error {
  constructor() {
    super('NCALayer is not available');
  }
}
